export default "__VITE_ASSET__d0ae6049__"